import keyMirror from 'keymirror'

export const SITE_TYPE = keyMirror({
  PHYSICAL: null,
  VIRTUAL: null,
})
